// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#kpi2[data-v-afc90594]{position:relative;width:100%;height:95%;box-sizing:border-box}#kpi2 .box[data-v-afc90594]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
